module.exports = __webpack_public_path__ + "static/media/2001.2445e667.png";